import { useAuth0 } from "@auth0/auth0-react";
import React, { useEffect } from "react";

export const CheckValidUser = () => {
  const originUrl = window.location.origin;
  const { logout } = useAuth0();
  useEffect(() => {
    const logOut = () => {
      setTimeout(() => {
        logout({ returnTo: originUrl });
      }, [5000]);
    };
    logOut();
    //eslint-disable-next-line
  }, [originUrl]);

  return (
    <div
      style={{
        position: "fixed",
        background: "azure",
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,
        zIndex: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "2rem",
      }}
    >
      {`You are not allowed to access this area`}
    </div>
  );
};
